export const OFFER_PRODUCTS = '/offer-products';
export const OFFER_ROOT = 'offer_root';
export const DOT_ICON =
  'https://images-static.naikaa.com/media/wysiwyg/uiTools/2025-11/Interpunct.jpg';

export const toShowViewProducts = (
  isViewProducts: boolean | undefined,
  isStatic: boolean | undefined,
  id: number | undefined
) => !!(isViewProducts && id && !isStatic);

export const getOfferListingUrl = (offerId: number, rootParam: string) =>
  `${OFFER_PRODUCTS}/${offerId}?${OFFER_ROOT}=${rootParam}`;
